import React from "react";
import { IconProps } from "./IconProps";

const EnvelopeIcon: React.FC<IconProps> = ({
  size,
  thickness,
  ariaLabel,
  color = "currentColor",
}) => {
  switch (`${size}${thickness}`) {
    case "20Light":
      return (
        <svg
          aria-label={ariaLabel}
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M17.99 4.48C17.99 4.48 17.99 4.4 17.97 4.36C17.95 4.32 17.93 4.28 17.9 4.25C17.88 4.23 17.88 4.2 17.86 4.18C17.83 4.15 17.79 4.13 17.75 4.1C17.72 4.08 17.7 4.06 17.68 4.05C17.65 4.04 17.62 4.04 17.59 4.03C17.55 4.02 17.51 4.01 17.46 4C17.46 4 17.46 4 17.45 4H2.56C2.56 4 2.56 4 2.55 4C2.51 4 2.47 4.01 2.42 4.03C2.39 4.03 2.36 4.03 2.33 4.05C2.3 4.06 2.28 4.08 2.26 4.1C2.22 4.12 2.18 4.15 2.15 4.18C2.13 4.2 2.12 4.23 2.11 4.25C2.08 4.29 2.06 4.32 2.04 4.36C2.03 4.4 2.02 4.44 2.02 4.48C2.02 4.51 2 4.54 2 4.57V15.11C2 15.42 2.13 15.73 2.35 15.95C2.4 16 2.47 16.03 2.52 16.07C2.52 16.07 2.52 16.07 2.53 16.07C2.72 16.2 2.94 16.29 3.18 16.29H16.82C17.06 16.29 17.28 16.2 17.47 16.07C17.47 16.07 17.47 16.07 17.49 16.06C17.55 16.02 17.61 15.99 17.66 15.94C17.88 15.72 18.01 15.41 18.01 15.1V4.57C18.01 4.57 18 4.51 17.99 4.48ZM16.82 14.39L12.19 10.15L16.87 5.87L16.83 14.39H16.82ZM3.13 5.87L7.8 10.15L3.13 14.44V5.87ZM10 10.62L4.03 5.14H15.98L10 10.62ZM8.65 10.92L9.62 11.81C9.73 11.91 9.87 11.96 10 11.96C10.13 11.96 10.28 11.91 10.38 11.81L11.35 10.92L15.97 15.15L4.07 15.11L8.64 10.92H8.65Z"
            fill={color}
          />
        </svg>
      );
    case "20Thin":
      return (
        <svg
          aria-label={ariaLabel}
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.4903 4H2.49969C2.21986 4 2 4.21986 2 4.49969V15.1131C2 15.4129 2.11993 15.6927 2.32979 15.9126C2.53966 16.1224 2.82948 16.2423 3.12929 16.2423H16.8707C17.1705 16.2423 17.4503 16.1224 17.6702 15.9126C17.8801 15.7027 18 15.4129 18 15.123V4.49969C18 4.21986 17.7801 4 17.5003 4H17.4903ZM7.89632 10.1262L2.99938 14.6034V5.63898L7.89632 10.1262ZM3.78888 4.99938H16.2111L11.0344 9.74641C11.0344 9.74641 11.0144 9.7564 11.0144 9.7664L10.005 10.6958L8.99563 9.7664C8.99563 9.7664 8.97564 9.74641 8.96565 9.74641L3.78888 4.99938ZM8.63585 10.7958L9.66521 11.7352C9.85509 11.9151 10.1449 11.9151 10.3448 11.7352L11.3741 10.7958L16.2211 15.243H3.78888L8.63585 10.7958ZM12.1037 10.1162L16.9906 5.63898V14.6134L12.0937 10.1262L12.1037 10.1162Z"
            fill={color}
          />
        </svg>
      );
    case "32Light":
      return (
        <svg
          aria-label={ariaLabel}
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M27.75 6H3.75C3.55109 6 3.36032 6.07902 3.21967 6.21967C3.07902 6.36032 3 6.55109 3 6.75V23.75C3 24.2141 3.18437 24.6592 3.51256 24.9874C3.84075 25.3156 4.28587 25.5 4.75 25.5H26.75C27.2141 25.5 27.6592 25.3156 27.9874 24.9874C28.3156 24.6592 28.5 24.2141 28.5 23.75V6.75C28.5 6.55109 28.421 6.36032 28.2803 6.21967C28.1397 6.07902 27.9489 6 27.75 6ZM15.75 16.7325L5.6775 7.5H25.8225L15.75 16.7325ZM12.4587 15.75L4.5 23.045V8.455L12.4587 15.75ZM13.5688 16.7675L15.25 18.3025C15.3883 18.429 15.5689 18.4991 15.7563 18.4991C15.9436 18.4991 16.1242 18.429 16.2625 18.3025L17.9375 16.7675L25.8225 24H5.67875L13.5688 16.7675ZM19.0413 15.75L27 8.455V23.045L19.0413 15.75Z"
            fill={color}
          />
        </svg>
      );
    default:
      return null;
  }
};

export default EnvelopeIcon;
